export const CHECK_FOR_UPDATE_TOPIC = 'check_for_update_topic';
export const CLOSE_DRAWING_EDITOR_TOPIC = 'close_drawing_editor_topic'
export const OPEN_DRAWING_EDITOR_TOPIC = 'open_drawing_editor_topic'
export const OPEN_PDF_OVERVIEW_TOPIC = 'open_pdf_overview_topic'
export const CLOSE_PDF_OVERVIEW_TOPIC = 'close_pdf_overview_topic'
export const TOGGLE_MENU_TOPIC = 'toggle_menu_topic';
export const DELETE_CURRENT_REPORT_TOPIC = 'delete_current_report_topic';
export const FORCE_CLOSE_MENU_TOPIC = 'force_close_menu_topic';
export const REPORT_EDITOR_CLOSE_ALL_TABS_TOPIC = 'close_section_topic';
export const REPORT_EDITOR_OPEN_ALL_TABS_TOPIC = 'open_section_topic';
export const DRAWING_MODIFICATION_TOPIC = 'drawing_modification_topic'
export const IMAGE_CLICK_TOPIC = 'image_click_topic'
export const DELETE_IMAGE_CLICK_TOPIC = 'delete_image_click_topic'
export const PRINCIPAL_IMAGE_CLICK_TOPIC = 'principal_image_click_topic'
export const IMAGE_UPLOADED_TOPIC = 'image_uploaded_topic'
export const SAVE_CURRENT_REPORT_TOPIC = 'save_current_report_topic'
export const DISPLAY_ALERT_TOPIC = 'display-alert-topic'
export const OPEN_SIGNATURE_MODULE_TOPIC = 'open-signature-module-topic'
export const OPEN_CLOSE_REPORT_SCREEN_TOPIC = 'open-close-report-screen-topic'
export const CLOSE_CLOSE_REPORT_SCREEN_TOPIC = 'close-close-report-screen-topic'
export const CLOSE_SIGNATURE_MODULE_TOPIC = 'close-signature-module-topic'
export const PDF_STEP_COMPLETE_TOPIC = 'pdf-step-complete-topic'
export const NB_REPORTS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const NB_ITEMS_SEARCH_RESULT_CHANGED_TOPIC = 'nb-results-changed'
export const CONDITION_REPORT_PDF_UPLOADED = "condition-report-pdf-uploaded"